import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import privacy from '../images/privacy.png';
import gvLogo from '../images/gvLogo.png';

import '../css/home.css';

export default function Privacy() {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: '#3B4E68',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingBottom: '20px',
        }}
      >

        <Box>

          <Box>
            <img src={gvLogo}
              alt="gridvault logoprivacy image"
              className='home-icon'
              style={{ width: '100%' }}
            />
          </Box>

          <img src={privacy}
            alt="privacy image"
            className='home-icon'
            style={{ width: '100%' }}
          />

          <Box>
            <Typography
              variant='h4'
              sx={{
                color: 'white',
                padding: '20px',
                fontSize: '22px',
                fontWeight: 'bold',
              }}
            >
              Gridvault respects your privacy
            </Typography>

            <Typography
              variant='body1'
              sx={{
                color: 'white',
                fontSize: '14px',
                padding: '20px',
              }}
            >
              We collect required diagnostic data to keep the app secure and updated. This does not include any personal data.
            </Typography>
          </Box>

        </Box>

        <Box>
          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <Link to='/agree' >
              <Button
                sx={{
                  backgroundColor: '#3c82f6',
                  border: '1px solid #3B4E68',
                  color: '#FFFFFF',
                  width: '90%',
                  '&:hover': {
                    border: '1px solid #FFFFFF',
                    color: '#FFFFFF',
                  }
                }}
              >
                Accept
              </Button>
            </Link>
          </Box>

          <Box
            sx={{
              fontSize: '0.8rem',
            }}
          >
            <Link
              to='/privacy-statement'
              className="gv-links"
            // style={{ color: '#60a5fa', textDecoration: 'none', '&:hover': { color: '#FFFFFF' } }}
            >
              Gridvault Privacy Statement
            </Link>
          </Box>

        </Box>

      </Box>
    </React.Fragment >
  );
}